import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';
import { RightMenuService } from 'src/app/services/right-menu/right-menu.service';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss']
})
export class SidebarItemComponent implements OnInit {

  @Input() menuItem: MenuItem;
  public permissions = JSON.parse(localStorage.getItem('permissions'));
  public isCollapsed = true;

  constructor(
    public rightMenuService: RightMenuService,
  ) { }

  ngOnInit(): void {
    this.rightMenuService.toggleMenuObservable.subscribe((data: boolean) => {
      if(!data) {
        console.log(data);
        
        if(this.rightMenuService.currentMenuItem) {
          if(this.menuItem.label == this.rightMenuService.currentMenuItem.label) {
            this.isCollapsed = false;
          } 
        } else {
          this.isCollapsed = true;
        } 
      } else {
        this.isCollapsed = true;
      } 
    });
  }

  /*
  ██╗  ██╗ █████╗ ███████╗██████╗ ███████╗██████╗ ███╗   ███╗██╗███████╗███████╗██╗ ██████╗ ███╗   ██╗
  ██║  ██║██╔══██╗██╔════╝██╔══██╗██╔════╝██╔══██╗████╗ ████║██║██╔════╝██╔════╝██║██╔═══██╗████╗  ██║
  ███████║███████║███████╗██████╔╝█████╗  ██████╔╝██╔████╔██║██║███████╗███████╗██║██║   ██║██╔██╗ ██║
  ██╔══██║██╔══██║╚════██║██╔═══╝ ██╔══╝  ██╔══██╗██║╚██╔╝██║██║╚════██║╚════██║██║██║   ██║██║╚██╗██║
  ██║  ██║██║  ██║███████║██║     ███████╗██║  ██║██║ ╚═╝ ██║██║███████║███████║██║╚██████╔╝██║ ╚████║
  ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝     ╚══════╝╚═╝  ╚═╝╚═╝     ╚═╝╚═╝╚══════╝╚══════╝╚═╝ ╚═════╝ ╚═╝  ╚═══╝

  */
  /**
   * FUNCTION hasPermission
   * 
   * @param item 
   * @returns 
   */
  hasPermission(item: MenuItem): boolean {
    if (item.permissionRequired) {
      return this.permissions.includes(item.permissionRequired);
    }
    return true;
  }

}
